import { Component, OnInit } from '@angular/core';
import { ChallengesService } from '../../model/challenges/challenges.service';
import { ToastrService } from 'ngx-toastr';
import { forkJoin } from 'rxjs';
import { PageChangedEvent } from 'ngx-bootstrap/pagination';
import { CommonStatus, CommonStatusDetails, Globals, UserRole } from '../../globals/globals';
import { AuthService } from '../../model/auth-model/auth.service';
import { LocalizationService, TranslationParams } from 'src/app/util/service/internationalization/localization.service';
import { Translations } from 'src/app/util/service/internationalization/translations.service';
import { CustomMapQuery, ICustomMap } from './models/i-custom-map';
import { MapTypeDetails } from './constants/map-type-details';
import { SelectOptionType, ShowOptionValue } from '../locale/enum/Locale-serach-box-enum';
import SystemConstants from 'src/app/util/constants/SystemConstants';
import { CustomTypeAttribute, IGlobals, UserType } from 'src/app/globals/custom-types/global-custom-types';
import { IGetUser } from 'src/app/interface/user/i-get-user';
import { MapType } from './enum/map-type';
import { GlobalService } from 'src/app/util/service/global.service';
import { ConfirmationDialogComponent } from 'src/app/controller/confirmation-dialog/confirmation-dialog.component';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'app-manage-map',
    templateUrl: '../../view/manage-map/manage-map.component.html',
    styleUrls: ['../../view/manage-map/manage-map.component.scss'],
    standalone: false
})
export class ManageMapComponent implements OnInit {

  editIndex: number = -1
  isMapFormVisible: boolean
  localeListBindValueField = SelectOptionType;
  localeListBindLabelField = ShowOptionValue;
  mapList: ICustomMap[]
  pageAttributes: CustomTypeAttribute<IGlobals['adminPaginationAttrs'], any>;
  searchedLocale: string;
  searchedMapText: string;
  userData: UserType;
  loginUser: IGetUser;
  token: string;
  modalRef : BsModalRef;
  currentPage : number;
  isClearValue: boolean;

  private toCreatedMap(data: any): ICustomMap | null {
    const createdMap = data?.ops?.[0] || data;
    if (createdMap && typeof createdMap === 'object' && '_id' in createdMap) {
      return createdMap as ICustomMap;
    }
    return null;
  }

  constructor(
    private toastr: ToastrService,
    public globals: Globals,
    private authService: AuthService,
    private challengeModelService: ChallengesService,
    private globalService: GlobalService,
    private localizationService: LocalizationService,
    public translations: Translations,
    private modalService: BsModalService,
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.authService.isLoggedIn.subscribe((isLogin: boolean) => {
      if (isLogin) {
        this.pageAttributes = Object.assign({}, this.globals.adminPaginationAttrs);
        const loginUserData = this.authService.getUserData();
        this.loginUser = loginUserData.data;
        this.userData = UserRole;
        this.token = this.authService.getToken()
        this.getChallengMapListAndCounts();
      }
    }, err => {
      console.log(err);
    });
  }


  /**
   * This is used to add search fields in query
   * @param queryObj any
  */
  setSearchFields(queryObj: CustomMapQuery) {
    if (this.searchedMapText) {
      queryObj.name = this.searchedMapText;
    }
    if(this.searchedLocale) {
      queryObj.localeId = this.searchedLocale
    }
  }


  /**
   * This is used to handle multi req handle
  */
  getChallengMapListAndCounts(): void {
    forkJoin([
      this.getChallengMapList(this.pageAttributes.limits, this.pageAttributes.skips),
      this.getChallengMapCounts(),
    ]);
  }

  /**
   * copy map from list
   */
  setChallengMapForCopy(map: ICustomMap) {
    let copiedMap = this.globalService.getDeepCopy(map)
    delete copiedMap._id
    copiedMap.name = this.globalService.getCopiedNameWithTimeStamp(copiedMap.name)
    this.challengeModelService.createChallengMap(copiedMap).subscribe(res => {
      if (res && res.status === SystemConstants.OKAY_MSG) {
        this.localizationService.displayToastrSuccess(this.toastr, this.translations.GLOBAL.SUCCESS_MESSAGES.COPIED)
        const createdMap = this.toCreatedMap(res?.data);
        if (createdMap) {
          this.mapList.splice(0, 0, createdMap);
          this.getChallengMapListAndCounts()
        }
      } else {
        this.toastr.error(SystemConstants.ERROR, res.errMsg);
      }
    }, err => {
      if (err && err.error && err.error.error && err.error.error.message) {
        this.toastr.error(SystemConstants.ERROR, err.error.error.message);
      }
    });
  }

  /**
   * Delete map from list
   */
  
  openDeletePopup(mapId: string) {
    this.closeDialogBox();
    const config = {
      backdrop: true,
      ignoreBackdropClick: true,
      class: SystemConstants.CONFIRMATION_POP_UP_CLASS,
      initialState:{
        title: SystemConstants.DELETE,
        icon: SystemConstants.CONFIRMATION_POP_UP_ICON
      }
    };
    this.modalRef = this.modalService.show(ConfirmationDialogComponent, config);
    this.modalRef.onHidden.subscribe((flagResponse: boolean) => {
      if (typeof flagResponse === SystemConstants.BOOLEAN) {
        this.deleteChallengMap(mapId);
        this.modalRef.hide();
      }
    });
  }

  deleteChallengMap(id: string) {
    this.challengeModelService.updateChallengeMap(id, { status: CommonStatus.DELETE }).subscribe(res => {
      if (res && res.status === SystemConstants.OKAY_MSG) {
        this.localizationService.displayToastrSuccess(this.toastr, this.translations.GLOBAL.SUCCESS_MESSAGES.DELETED)
        this.getChallengMapListAndCounts()
      }
      else{
        this.localizationService.displayToastrError(this.toastr, this.translations.GLOBAL.ERROR_MESSAGES.UNABLE_TO_DELETE)
      }
    }, err => {
      if (err && err.errMsg) {
        this.toastr.error(SystemConstants.ERROR, err.errMsg);
      }
    });
  }

  toggleForm(isFormVisible?: boolean): void | boolean{
    if(this.searchedMapText){
      this.isClearValue = true
    }else{
      this.isClearValue = false
      this.getChallengMapListAndCounts();
    }
    this.editIndex = -1;
    this.isMapFormVisible = isFormVisible ? true : false;
  }

  closeDialogBox(){
    if(this.editIndex>= SystemConstants.ZERO_DEFAULT || this.isMapFormVisible){
      this.isMapFormVisible = false;
      this.editIndex = -1
    }
  }

  searchByLocale(locale: string) {
    this.closeDialogBox()
    this.searchedLocale = locale != SystemConstants.ALL_LOCALE ? locale : '';
    this.resetPageUrl()
    this.getChallengMapListAndCounts();
  }

  searchByText(text: string) {
    this.closeDialogBox()
    this.searchedMapText = text
    this.resetPageUrl()
    this.getChallengMapListAndCounts()
  }

  showErrorMessageForMapCreation() {
    this.localizationService.displayToastrError(this.toastr, this.translations.GLOBAL.ERROR_MESSAGES.UNABLE_TO_CREATE)
  }

  clearSearchValue(){
    this.searchedMapText = '';
  }

  showSuccessMessageForMapCreation() {
    this.clearSearchValue();
    this.localizationService.displayToastrSuccess(this.toastr, this.translations.GLOBAL.SUCCESS_MESSAGES.CREATED)
    this.toggleForm()
    this.getChallengMapListAndCounts()
    // this.searchedMapText = "";
    // this.searchByText(this.searchedMapText);
  }

  showErrorMessageForMapUpdation() {
    this.localizationService.displayToastrError(this.toastr, this.translations.GLOBAL.ERROR_MESSAGES.UNABLE_TO_UPDATING)
  }

  showSuccessMessageForMapUpdation() {
    this.localizationService.displayToastrSuccess(this.toastr, this.translations.GLOBAL.SUCCESS_MESSAGES.UPDATED)
    this.toggleForm()
    this.getChallengMapListAndCounts()
  }

  /**
   * This is used to get map list by passing limit, skip
   * @param limit number
   * @param skip number
  */
 getChallengMapList(limit: number, skip: number) {
    const queryObj: CustomMapQuery = { limit, skip };
    this.route.queryParamMap.subscribe(params => {
      this.currentPage = Number(params.get(SystemConstants.PAGE)) || SystemConstants.DEFAULT_PAGE_NUMBER;
    });
    this.setSearchFields(queryObj);
    this.challengeModelService.getChallengMapList(queryObj).subscribe(res => {
      if (res && res.status === SystemConstants.OKAY_MSG) {
        this.mapList = res.data;
      } else {
        this.toastr.error(SystemConstants.ERROR, res.errMsg);
      }
    }, err => {
      if (err && err.error && err.error.error && err.error.error.message) {
        this.toastr.error(SystemConstants.ERROR, err.error.error.message);
      }
    });
  }

  /**
   * This is used to get map counts
  */
  getChallengMapCounts() {
    const queryObj: CustomMapQuery = {};
    this.setSearchFields(queryObj);
    this.challengeModelService.getChallengMapCounts(queryObj).subscribe(res => {
      if (res && res.status === SystemConstants.OKAY_MSG) {
        this.pageAttributes.count = res.data ? res.data : 0;
      }
    }, err => {
      if (err && err.error && err.error.error && err.error.error.message) {
        this.toastr.error(SystemConstants.ERROR, err.error.error.message);
      }
    });
  }

  /**
   * Used for pagination
   * @param event PageChangedEvent
   */
  pageChanged(event: PageChangedEvent): void {
    if(this.editIndex>= SystemConstants.ZERO_DEFAULT) this.closeDialogBox()
    const startItem = (event.page - 1) * event.itemsPerPage;
    this.currentPage = event.page
    this.router.navigate([], {
      queryParams: { page: this.currentPage },
      queryParamsHandling: SystemConstants.MERGE
    });
    this.pageAttributes.skips=startItem;
    this.getChallengMapList(this.pageAttributes.limits, startItem);
    this.globalService.scrollOnTop();
  }
  resetPageUrl(){
    this.router.navigate([], {
      queryParams: { page: SystemConstants.DEFAULT_PAGE_NUMBER},
      queryParamsHandling: SystemConstants.MERGE
    });
  }

  setChallengeMapForEdit(index: number) {
    this.toggleForm()
    this.editIndex = index
  }

  get mapType(): typeof MapTypeDetails {
    return MapTypeDetails
  }

  get mapTypeEnum(): typeof MapType {
    return MapType
  }

  get status(): typeof CommonStatusDetails {
    return CommonStatusDetails
  }

  getTranslation(key: string, options?: TranslationParams): string {
    return this.localizationService.getTranslation(key, options);
  }
}
